export default __webpack_public_path__ + "static/media/decorationAboveFooter_desktop.7011b929.svg";